import type { HelpFile } from '../../types/help'
import { FormLayoutDesignerPageTestIds } from '../../../testids/FormLayoutDesignerPageTestIds'

export const formLayoutDesignerPageHelp: HelpFile = {
  docPage: '/docs/schema/form-layouts',
  texts: {
    [FormLayoutDesignerPageTestIds.formLayoutDesignerPage]:
      'Visueller Designer zum Anordnen von Feldern, Abschnitten und Reitern eines von einem Entitätstyp genutzten Formularlayouts.',
    [FormLayoutDesignerPageTestIds.designerCancelBtn]:
      'Änderungen verwerfen und zur Layout-Liste zurückkehren.',
    [FormLayoutDesignerPageTestIds.designerSaveBtn]:
      'Aktuelles Layout speichern — die neue Anordnung wird sofort für alle Benutzer wirksam.',
    [FormLayoutDesignerPageTestIds.usedOnPageLink]:
      'Öffnet die Seite oder Entität, die dieses Layout aktuell verwendet, um die Darstellung zu prüfen.',
    [FormLayoutDesignerPageTestIds.unsavedChangesDialog]:
      'Bestätigt, ob der Designer ohne Speichern verlassen werden soll — der Dialog erscheint beim Klick auf Abbrechen mit ungespeicherten Änderungen.',
    [FormLayoutDesignerPageTestIds.unsavedChangesStayBtn]:
      'Auf der Seite bleiben und weiter bearbeiten — Ihre ungespeicherten Änderungen bleiben erhalten.',
    [FormLayoutDesignerPageTestIds.unsavedChangesLeaveBtn]:
      'Ohne Speichern verlassen — die ungespeicherten Änderungen werden verworfen.',
    [FormLayoutDesignerPageTestIds.conflictDialog]:
      'Weist darauf hin, dass ein anderer Benutzer dieses Layout während Ihrer Bearbeitung gespeichert hat — wählen Sie eine Wiederherstellungsaktion.',
    [FormLayoutDesignerPageTestIds.conflictKeepEditingBtn]:
      'Ihre Version weiter bearbeiten — der konkurrierende Speichervorgang bleibt für andere sichtbar, bis Sie erneut speichern.',
    [FormLayoutDesignerPageTestIds.conflictDiscardBtn]:
      'Lokale Änderungen verwerfen und das Layout vom Server neu laden.',
  },
}
